'use client';

import { useRouter } from 'next/navigation';

import { CrossIcon } from '@/components/ui/Icons/Icons';

import * as S from './AuthWrapper.styles';

export const CrossButton = () => {
  const { back } = useRouter();

  return (
    <S.CrossButton onClick={back}>
      <CrossIcon />
    </S.CrossButton>
  );
};
